import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { PostfixPopupLink } from 'shared/components/PostfixPopupLink';
import { useFilterChangeCallback, useRuntimeSetting } from 'shared/hooks';
import { selectCommercialLink } from 'shared/selectors/commercialLink';
import { selectDealType, selectOfferType } from 'shared/selectors/jsonQuery';

import { FDealType, FOfferType } from '../../../../../packages/JsonQuery';
import { FILTER_KEY } from '../../constants';

const COMMERCIAL_ENABLED_KEY = 'isNewCommercialSerpDesign.Desktop.Enabled';

interface IOfferTypePopupPostfixProps {
  onClose?: () => void;
}

function getNextOfferType(isCurrentCommercial: boolean, dealType: FDealType): FOfferType {
  if (isCurrentCommercial) {
    return (dealType & FDealType.Sale) !== 0 ? FOfferType.FlatNew : FOfferType.FlatOld;
  }

  return FOfferType.Office;
}

export function OfferTypePopupPostfix({ onClose }: IOfferTypePopupPostfixProps) {
  const dealType = useSelector(selectDealType);
  const offerType = useSelector(selectOfferType);
  const commercialLink = useSelector(selectCommercialLink);
  const isCommercialEnabled = useRuntimeSetting<boolean>(COMMERCIAL_ENABLED_KEY, false);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const isCurrentCommercial = (offerType & FOfferType.Commercial) !== 0;

  const handleInlineToggle = useCallback(() => {
    const nextOfferType = getNextOfferType(isCurrentCommercial, dealType);

    onClose?.();
    onChange({ action: 'setOfferType', arguments: [nextOfferType] });
  }, [isCurrentCommercial, dealType, onClose, onChange]);

  if (isCommercialEnabled) {
    if (dealType === FDealType.RentDaily) {
      return null;
    }

    const text = isCurrentCommercial ? 'Жилая' : 'Коммерческая';
    const href = commercialLink ?? '/';

    return <PostfixPopupLink href={href} text={text} onClick={handleInlineToggle} />;
  }

  if (dealType === FDealType.RentDaily || !commercialLink) {
    return null;
  }

  return <PostfixPopupLink href={commercialLink} text="Коммерческая" />;
}
